import { render, staticRenderFns } from "./IconsPush.vue?vue&type=template&id=fab9f094&scoped=true&"
import script from "./IconsPush.vue?vue&type=script&lang=js&"
export * from "./IconsPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab9f094",
  null
  
)

export default component.exports